import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const paymentV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate paymentButton element to v2',
  run: (props: PartialPropsOf<'paymentButton'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.style?.font);
  },
};
